import { render, staticRenderFns } from "./AvatarChatInterface.vue?vue&type=template&id=fd785bc2&scoped=true"
import script from "./AvatarChatInterface.vue?vue&type=script&lang=js"
export * from "./AvatarChatInterface.vue?vue&type=script&lang=js"
import style0 from "./AvatarChatInterface.vue?vue&type=style&index=0&id=fd785bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd785bc2",
  null
  
)

export default component.exports